import '../css/Sidebar.css'
import Fields from './Fields'
import Customize from './Customize'

function Sidebar({ field, fieldHandler, design, designHandler, mode }) {
   return (
      <div className="sidebar">
         {mode === 'fields' ? (
            <Fields field={field} fieldHandler={fieldHandler} />
         ) : (
            <Customize design={design} designHandler={designHandler} />
         )}
      </div>
   )
}

export default Sidebar
